import { Vector3 } from "../System.Numerics.Vector3.gen";
import { read_f32, Sink } from "../../helpers/serializerHelpers";

export class PointCloudSpherical {
    public range: number = 0; //in m
    public angle: number = 0; // in rad
    public elevation: number = 0; //in rad
    public doppler: number = 0;

    //These are set in the parsing code
    public x?: number;
    public y?: number;
    public z?: number;
    public isInRange?: boolean;
    public isStatic?: boolean;
    public isClutter?: boolean;
    public cartesianPosition() { return new Vector3({ x: this.x ?? 0, y: this.y ?? 0, z: this.z ?? 0 }) }

    public deserialize(bytes: Sink) {
        if (bytes.view.byteLength - bytes.pos < this.getLength()) { return this; }
        this.range = read_f32(bytes);
        this.angle = read_f32(bytes);
        this.elevation = read_f32(bytes);
        this.doppler = read_f32(bytes);

        return this;
    }

    public getLength() {
        return 4 * 4;
    }

    public toString() { return (`PointCloud Range ${this.range} Angle ${this.angle} Elevation ${this.elevation} Position ${this.x},${this.y},${this.z}`) };
}
